module.exports = __webpack_public_path__ + "img/health_center.830df5f2.png";